"use client"
import {
  Table
} from "./chunk-CFQULO2Q.mjs";

// src/components/paging-table.ts
import { mergeMultiStyle } from "@yamada-ui/core";
var PagingTable = mergeMultiStyle(
  Table,
  {
    baseStyle: {
      pagingControl: {
        gridTemplateColumns: "1fr 5fr 1fr"
      }
    },
    sizes: {
      sm: {
        pagingControl: {
          gap: 2
        }
      },
      md: {
        pagingControl: {
          gap: 4
        }
      },
      lg: {
        pagingControl: {
          gap: 6
        }
      },
      xl: {
        pagingControl: {
          gap: 8
        }
      }
    }
  }
)();

export {
  PagingTable
};
//# sourceMappingURL=chunk-7YQ4XJJJ.mjs.map